import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { subscribeToNewsletter } from "../../actions/newsletterActions";

import "./HomeNewsletter.css";

export default function HomeNewsletter() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [website, setWebsite] = useState("");

  async function submitHandler(event) {
    event.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      setError("Please enter your email address.");
      return;
    }

    setSubmitting(true);
    setError("");
    setMessage("");

    try {
      const result = await dispatch(
        subscribeToNewsletter({
          email: trimmedEmail,
          source: "home_newsletter",
          website,
        }),
      );

      setMessage(result?.message || "Thank you. You are on the list.");
      setEmail("");
    } catch (submitError) {
      setError(
        submitError?.message ||
          "We could not save your subscription right now. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section
      className="home-newsletter"
      aria-labelledby="home-newsletter-title"
    >
      <div className="home-newsletter__inner">
        <div className="home-newsletter__content">
          <p className="home-newsletter__kicker">New drops</p>

          <h2 id="home-newsletter-title">
            Sign up for archive arrivals and specialist finds.
          </h2>

          <p>
            Receive occasional updates on replica garments, archive textiles,
            vintage haberdashery and newly listed pieces.
          </p>
        </div>

        <form className="home-newsletter__form" onSubmit={submitHandler}>
          <div className="home-newsletter__honeypot" aria-hidden="true">
            <label htmlFor="newsletter-website">Website</label>
            <input
              id="newsletter-website"
              name="website"
              value={website}
              autoComplete="off"
              tabIndex={-1}
              onChange={(event) => setWebsite(event.target.value)}
            />
          </div>

          <label className="home-newsletter__label" htmlFor="newsletter-email">
            Email address
          </label>

          <div className="home-newsletter__field">
            <input
              id="newsletter-email"
              type="email"
              name="email"
              value={email}
              placeholder="your@email.com"
              autoComplete="email"
              onChange={(event) => {
                setEmail(event.target.value);
                setMessage("");
                setError("");
              }}
              disabled={submitting}
            />

            <button type="submit" disabled={submitting}>
              {submitting ? "Signing up..." : "Sign up"}
            </button>
          </div>

          <p className="home-newsletter__consent">
            By signing up, you agree to receive occasional marketing emails
            from Academy Costumes London. You can unsubscribe at any time.
          </p>

          {message && (
            <p className="home-newsletter__message" role="status">
              {message}
            </p>
          )}
          {error && (
            <p
              className="home-newsletter__message home-newsletter__message--error"
              role="alert"
            >
              {error}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
